import React from "react";
import Common_Title from "../../common-components/common_title/Common_Title";
import "./Who_We_Are.css";
import parse from "html-react-parser";

function Who_We_Are({ content }) {
  return (
    <section className="who_we_are_section">
      <div className="container">
        <div className="title">
          <Common_Title titleStart="Who we are" />
        </div>

        <div className="who_section">
          <div className="text_wrapper">
            <p className="text">{parse(content?.content || "")}</p>
          </div>

          <div className="image_wrapper">
            <img
              src={process.env.REACT_APP_IMG_URL + content?.video}
              // src="/assets/images/about_us/who-we-are/who-we-are-banner.png"
              alt="who-banner"
              className="who-banner"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Who_We_Are;
